import { render, staticRenderFns } from "./MainTowerCard.vue?vue&type=template&id=ab1d8db0&scoped=true&"
import script from "./MainTowerCard.vue?vue&type=script&lang=js&"
export * from "./MainTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MainTowerCard.vue?vue&type=style&index=0&id=ab1d8db0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1d8db0",
  null
  
)

export default component.exports